var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-4",staticStyle:{"padding-left":"10px"}},[_c('span',{class:{'textGroupHeader': true, 'today': _vm.isToday}},[_vm._v(_vm._s(_vm.formattedGroupTile))])])}
var staticRenderFns = []

export { render, staticRenderFns }